
import { defineComponent,onMounted,reactive,ref,toRefs,getCurrentInstance, watch, nextTick} from 'vue'
import searchBtn  from './searchEl.vue'
import {useRouter,useRoute} from 'vue-router'
import router from '@/router'
export default defineComponent({
    props:{
        isScroll:{
            type:Boolean,
            default:false
        },
        showSearch:{
            type:Boolean,
            default:false
        }
    },
    components:{searchBtn},
    setup(prop) {
        const {proxy,appContext} = getCurrentInstance() as any;
        const route= useRoute()
        const router=useRouter()
        const state:any=reactive({
            platformJson:appContext.config.globalProperties.platformJson,
            isArticle:false,
            articleSearch:false,
            data:{}
        })
        if(route.path.indexOf('/article')>=0||route.path.indexOf('/isArticle')>=0){
            state.isArticle=true
            state.articleSearch=true
        }
        console.log(route.path)
        const methods:any=reactive({
            handleClick:(link:any)=>{
                window.open(link,'_blank')
            },
            handleToHome:()=>{
                router.push('/index')
            },
            openYjStudy:()=>{
                // window.open('https://appo0gfiyw12825.pc.xiaoe-tech.com','_blank')
                window.open('https://learn.yijingcloud.com','_blank')
            },
            toHome:()=>{
                router.push('/index')
            }
        })
        onMounted(()=>{})
        watch(()=>prop.showSearch,(val)=>{
            if(val==true){
                nextTick(()=>{
                    console.log(proxy.$refs.searchBtn)
                    proxy.$refs.searchBtn.getData()
                })
            }
        })
        watch(()=>route.path,(val)=>{
            if(val.indexOf('/article')>=0||val.indexOf('/isArticle')>=0){
                console.log('/article')
                state.isArticle=true
                state.articleSearch=true
            }else{
                state.isArticle=false
                state.articleSearch=false
            }
        })
        return {
            ...toRefs(state),
            ...toRefs(methods),
        }
        
    }
})
